export const LOGIC_FIELDS = {
  TEN_POINT_SCALE: 'TEN_POINT_SCALE',
  SLIDER: 'SLIDER',
  SELECTED_OPTIONS: 'SELECTED_OPTIONS',
  /** Multiselect MCQ — count of selected option ids. */
  NUM_OF_SELECTED_OPTIONS: 'NUM_OF_SELECTED_OPTIONS',
  TEXT: 'TEXT',
  CASE_SENSITIVE_TEXT: 'CASE_SENSITIVE_TEXT',
  MATRIX_OPTIONS: 'MATRIX_OPTIONS',
  FILE_UPLOAD: 'FILE_UPLOAD',
  HEATMAP: 'HEATMAP',
  HEATMAP_REGION: 'HEATMAP_REGION',
  NUMBER: 'NUMBER',
  SELECTED_DATETIME: 'SELECTED_DATETIME',
  /** Per-option rank for RANK_ORDER questions. */
  RANK_ORDER: 'RANK_ORDER',
} as const;

export type LogicField = (typeof LOGIC_FIELDS)[keyof typeof LOGIC_FIELDS];
